(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["legeit-heavyweight-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('legeit-size-chart')) {
  customElements.define('legeit-size-chart', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.buttons = Array.from(this.querySelectorAll('[data-measurement-unit]'));
      this.values = Array.from(this.querySelectorAll('[data-measurement-value]'));
      this.caption = this.querySelector('[data-measurement-caption]');
      const guide = this.querySelector('dialog');
      this.querySelector('[data-measure-guide-open]').addEventListener('click', () => guide.showModal());
      this.querySelector('[data-measure-guide-close]').addEventListener('click', () => guide.close());
      guide.addEventListener('click', event => {
        const bounds = guide.getBoundingClientRect();
        if (event.target === guide && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) guide.close();
      });
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const unit = button.dataset.measurementUnit;
        this.buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.values.forEach(value => { value.hidden = value.dataset.measurementValue !== unit; });
        this.caption.textContent = unit.toUpperCase();
      }));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["legeit-product-information"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('legeit-product-information')) {
 customElements.define('legeit-product-information', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   const source = this.querySelector('[data-product-source]');
   if (!source) return;
   this.initialized = true;
   const original = source.cloneNode(true);
   const media = Array.from(original.querySelectorAll('img,table,video')).map(node => node.cloneNode(true));
   const intro = this.querySelector('[data-product-intro]');
   const story = original.querySelector('.product__story-copy');
   if (story) {
    intro.append(story);
    intro.hidden = false;
   }
   original.querySelectorAll('script,style,meta,svg,.share-link').forEach(node => node.remove());
   original.querySelectorAll('br').forEach(node => node.replaceWith('\n'));
   original.querySelectorAll('div,p,section,li,h1,h2,h3,h4,dt,dd').forEach(node => {
    node.prepend(document.createTextNode('\n'));
    node.append(document.createTextNode('\n'));
   });
   const lines = original.textContent.split(/\n+/).map(line => line.replace(/\s+/g, ' ').trim()).filter(Boolean);
   const featureList = document.createElement('ul');
   featureList.className = 'legeit-information__features';
   const fitList = this.querySelector('[data-product-fit]');
   const fabricList = this.querySelector('[data-product-fabric]');
   const known = /^(details|size|fit|style|color|colours|material|materials|fabric|care|care instructions|directions|caution|ingredients|features)\s*:\s*(.*)$/i;
   let group = 'details';
   const seen = new Map();
   const append = (list, text) => {
    if (!list || !text || list.hasAttribute('data-manual')) return;
    const normalized = text.toLocaleLowerCase();
    if (!seen.has(list)) seen.set(list, new Set(Array.from(list.children).map(item => item.textContent.replace(/\s+/g, ' ').trim().toLocaleLowerCase())));
    if (seen.get(list).has(normalized)) return;
    seen.get(list).add(normalized);
    const item = document.createElement('li');
    item.textContent = text;
    list.append(item);
   };
   for (let line of lines) {
    const heading = line.match(known);
    if (heading) {
     group = heading[1].toLowerCase();
     line = heading[2];
     if (!line) continue;
    }
    if ((group === 'size' || group === 'fit') && fitList) append(fitList, line);
    else if (['material','materials','fabric','care','care instructions'].includes(group) && fabricList) append(fabricList, line);
    else append(featureList, ['style','color','colours','directions','caution','ingredients'].includes(group) ? group.charAt(0).toUpperCase() + group.slice(1) + ': ' + line : line);
   }
   if (featureList.children.length || media.length) source.replaceChildren(featureList, ...media);
   else {
    source.replaceChildren();
    const panel = source.closest('details');
    if (!panel.querySelector('.legeit-product-details, [data-custom-features]')) panel.hidden = true;
   }
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
